









































































































































import Vue from "vue"
import axios from "axios"
import { makeOrderNumber } from "~/affiliatePrograms/a8sales"

interface DataType {
  form: {
    name: string
    mailAddress: string
    companyName: string
    phoneNumber: string
  }
  formValidator: {
    nameIsValid: boolean
    mailAddressIsValid: boolean
    companyNameIsValid: boolean
    phoneNumberIsValid: boolean
  }
  isDownloading: boolean
  fromAd: boolean
  orderNumber: string
}

const regexForEmail = /^([a-zA-Z0-9])+([a-zA-Z0-9\\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\\._-]+)+$/
const regexForPhoneNumber = /^0[0-9]{9,10}$/
const regexForPhoneNumberWithHyphen = /^0[0-9]{2,3}-[0-9]{1,4}-[0-9]{4}$/

const downloadPdfUrl =
  "https://crowdlinks-delivered-documents-prod.s3-ap-northeast-1.amazonaws.com/lp/crowdlinks.pdf"

export default Vue.extend({
  layout: "lp",
  data(): DataType {
    return {
      form: {
        name: "",
        mailAddress: "",
        companyName: "",
        phoneNumber: "",
      },
      formValidator: {
        nameIsValid: true,
        mailAddressIsValid: true,
        companyNameIsValid: true,
        phoneNumberIsValid: true,
      },
      isDownloading: false,
      fromAd: false,
      orderNumber: "",
    }
  },
  head(): object {
    return this.$clHelpers.metaTag.generate({
      title: "企業用資料ダウンロード｜クラウドリンクス",
      description:
        "従来までは難しかった地方の採用が変わります。クラウドリンクスでは、リモートワークや副業により都会ではたらく超一流企業の人材を活用できるようになりました。北海道から沖縄まで、全国の地方企業さまが利用しています。",
      currentPath: this.$nuxt.$route.path,
    })
  },
  created() {
    if (this.$route.query.from === "ad") {
      this.fromAd = true
      this.orderNumber = makeOrderNumber("downloadDocument")
    }
  },
  methods: {
    submit(): void {
      this.validateName()
      this.validateMailAddress()
      this.validateCompanyName()
      this.validatePhoneNumber()

      if (
        !(
          this.formValidator.nameIsValid &&
          this.formValidator.mailAddressIsValid &&
          this.formValidator.companyNameIsValid &&
          this.formValidator.phoneNumberIsValid
        )
      ) {
        return
      }

      this.isDownloading = true

      const baseUrl = process.env.SERVICE_BASE_URL

      axios
        .post(
          `${baseUrl}/api/client_lp/contact`,
          {
            lpType: this.fromAd
              ? "downloadDocument(affiliate)"
              : "downloadDocument",
            orderNumber: this.orderNumber,
            name: this.form.name,
            email: this.form.mailAddress,
            corporationName: this.form.companyName,
            phoneNumber: this.form.phoneNumber,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then(() => {
          window.open(downloadPdfUrl, "_blank")
          this.navigateToThanksPage()
        })
        .catch(() => {
          alert(
            "エラーが発生しました。大変申し訳ございませんが再度お試しください。"
          )
          this.isDownloading = false
        })
    },
    validateName(): void {
      this.formValidator.nameIsValid =
        this.form.name.length > 0 && this.form.name.length < 33
    },
    validateMailAddress(): void {
      this.formValidator.mailAddressIsValid =
        regexForEmail.test(this.form.mailAddress) &&
        !this.$clHelpers.emailAddress.isFreeAddress(this.form.mailAddress)
    },
    validateCompanyName(): void {
      this.formValidator.companyNameIsValid =
        this.form.companyName.length > 0 && this.form.companyName.length < 41
    },
    validatePhoneNumber(): void {
      this.formValidator.phoneNumberIsValid =
        regexForPhoneNumber.test(this.form.phoneNumber) ||
        regexForPhoneNumberWithHyphen.test(this.form.phoneNumber)
    },
    navigateToThanksPage(): void {
      this.$nuxt.$router.push({
        path: `/lp/thanks${
          this.fromAd ? `?orderNumber=${this.orderNumber}` : ""
        }`,
      })
    },
  },
})
